import { useEffect, useState } from "react";
import cancel from "../../../assets/cancel.png";
import "./Role_Form.css";

const Role_Form = ({ onClose, onSubmit, isEdit, isView, data, fetchRoles }) => {
  const [formData, setFormData] = useState({
    name: "",
    permissions: [],
  });
  const [errors, setErrors] = useState({});

  // Permissions based on LeftPane menu items (flattened)
  const permissionOptions = [
    { id: "dashboard", name: "Dashboard" },
    { id: "aboutus", name: "About Us" },
    { id: "advertisement", name: "Advertisement" },
    { id: "circular", name: "Circular" },
    { id: "application", name: "Application" },
    { id: "student", name: "Students" },
    { id: "existing_student", name: "Existing Student" },
    { id: "teacher", name: "Teacher" },
    { id: "fee", name: "Fees" },
    { id: "new_admission", name: "New Admission" },
    { id: "role", name: "Role" },
  ];

  useEffect(() => {
    if ((isEdit || isView) && data?.id) {
      // When editing or viewing, use existing data
      setFormData({
        id: data.id || "",
        name: data.name || "",
        permissions: data.permissions || [],
      });
    } else if (!isEdit && !isView) {
      // When creating a new role, set "dashboard" as default checked
      setFormData({
        name: "",
        permissions: ["dashboard"],
      });
    }
  }, [isEdit, isView, data]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleCheckboxChange = (e) => {
    const { id, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      permissions: checked ? [...prev.permissions, id] : prev.permissions.filter((perm) => perm !== id),
    }));
    setErrors((prev) => ({
      ...prev,
      permissions: "",
    }));
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Role Name is required";
    if (!formData.permissions.length && !isView) newErrors.permissions = "At least one permission is required";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!isView && !validateForm()) return;

    // Ensure dashboard is always included in permissions
    const submissionData = {
      ...formData,
      permissions: formData.permissions.includes("dashboard") 
        ? formData.permissions 
        : ["dashboard", ...formData.permissions]
    };

    onSubmit(submissionData);
    if (!isView) {
      onClose();
    }
  };

  return (
    <div className="role__form_div_open">
      <div className="role__form">
        <div className="role__form_header">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", width: "100%" }}>
            <h1 style={{ padding: "0", margin: "0", fontSize: "24px" }}>{isView ? "View Role" : isEdit ? "Edit Role" : "Add Role"}</h1>
            <div className="role__form_img" onClick={onClose}>
              <img src={cancel} alt="Close" />
            </div>
          </div>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="role__form_input">
            <h5>Role Name</h5>
            <input type="text" name="name" value={formData.name} onChange={handleChange} className={`role__form_input_small ${errors.name ? "input-error" : ""}`} placeholder="Enter role name" disabled={isView} />
            {errors.name && <span className="error">{errors.name}</span>}
          </div>
          <div className="role__form_input">
            <h5>Permissions</h5>
            <div className="role__form_input_checkbox">
              {permissionOptions.map((option) => (
                <label key={option.id} className="checkbox-label">
                  <input 
                    type="checkbox" 
                    id={option.id} 
                    checked={formData.permissions.includes(option.id)} 
                    onChange={handleCheckboxChange} 
                    disabled={isView || option.id === "dashboard"} 
                  />
                  {option.name}
                </label>
              ))}
            </div>
            {errors.permissions && <span className="error">{errors.permissions}</span>}
          </div>
          {!isView && (
            <button type="submit" className="role__form_button">
              {isEdit ? "UPDATE" : "Add Role"}
            </button>
          )}
          {isView && (
            <button type="button" className="role__form_button_close" onClick={onClose}>
              CLOSE
            </button>
          )}
        </form>
      </div>
    </div>
  );
};

export default Role_Form;
